module.exports = __webpack_public_path__ + "static/media/back5.06ff5ea8.png";